import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { SsrModule } from 'app/constants/ssrModules';
import { useTranslation } from 'app/lang';
import Footer from 'app/modules/Layout/Footer';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import { AccountInformation } from './components/AccountInformation';

import dictionary from './PersonalData.dictionary.json';

import styles from '../PersonalSubmodules.module.scss';

export const PersonalData: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          {t(dictionary.title)}
        </title>
      </Helmet>

      <ErrorBoundary>
        <section className={styles.container}
                 data-ssr-id={SsrModule.ACCOUNT}>
          <h2 className={styles.title}>
            {t(dictionary.title)}
          </h2>

          <AccountInformation />
        </section>

        <Footer />
      </ErrorBoundary>
    </>
  );
};
